
import React from 'react';
import { Lock as LockIcon } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Box } from '@mui/material';
import { classes, StyledBox } from './ConfirmationFinal.styles';


const ConfirmationFinal = () => (
  <StyledBox display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <Box display="flex" className={classes.circleContainer} justifyContent="center" alignItems="center">
      <LockIcon className={classes.deleteIcon} fontSize="large" />
    </Box>
    <div className={classes.textContainer}>
      <p>
          You have made changes to a Financial Table that is being used in a Allocation marked as final. These changes
          will alter the final allocation.
      </p>
    </div>
  </StyledBox>
);

export default ConfirmationFinal;
